import React, { useState } from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import { useUploadCvtLogs } from "../../../hooks/useUploadCvtLogs";
import { Button, SearchBar } from "../../../../common/APICommon";
import { LoadingSpinner } from "../../../../common/Loading";
import { CreateTableNew as CreateTable } from "../../../../common/APICommon";
import { DateInput } from "../../../../common/Input";
import { SetAuditTrail } from "../../../../components/Reports/AuditTrailReportEmployeeSetup";
import UploadCvtLogsPreviewModal from "./components/UploadCvtLogsPreviewModal";

const UploadCvtLogsModule = ({ user, showGeneralMessage }) => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dateFilters, setDateFilters] = useState({
    start: new Date().toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });

  const {
    loading,
    data,
    handleSearch,
    setPreviewData,
    previewData,
    fetchRecords,
    uploadBulkData,
    processCsvFile,
  } = useUploadCvtLogs({ showGeneralMessage });

  const onGenerate = () => fetchRecords(dateFilters.start, dateFilters.end);

  const onFinalSubmit = async (payload) => {
    const success = await uploadBulkData(payload);
    if (success) {
      await SetAuditTrail({
        setupArea: "Time Logs",
        actionTaken: "insert",
        field: "Excel Upload: CVT Logs",
        newValue: `Entries: ${payload.length}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      onGenerate();
      setIsUploadModalOpen(false);
    }
  };

  const headers = ["Emp ID", "Full Name", "Date Time Log", "Type", "Device"];
  const accessors = ["employeeId", "fullName", "dateTimeLog", "recordType", "deviceSerialNumber"];

  const renderCell = (row, accessor) => {
    if (accessor === "dateTimeLog") {
      return row[accessor] ? new Date(row[accessor]).toLocaleString('en-US', {
        year: 'numeric', month: 'short', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
      }) : "-";
    }
    // MODIFIED: Logic for string recordType
    if (accessor === "recordType") {
      const type = row[accessor]?.toUpperCase();
      return (
        <span className={`font-bold ${type === "IN" ? "text-green-600" : "text-orange-600"}`}>
          {type || "-"}
        </span>
      );
    }
    return row[accessor] || "-";
  };

  return (
    <div className="relative">
      <LoadingSpinner loading={loading} />

      <div className="w-full py-2 px-4 box-border">
        <div className="text-sm">
          <span className="text-gray-400">{"Time Keeping > "}</span>
          <span className="border-b border-black text-gray-700">{"Upload CVT Logs"}</span>
        </div>
        <div className="flex items-center justify-between border-b bg-white">
          <h3 className="text-xl font-bold m-0 text-blue-900 tracking-tight uppercase">
            CVT Bio Logs Sync
          </h3>
        </div>
      </div>

      <div className="p-4 space-y-4">
        <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm" style={{ border: "1px solid #d7d7d7" }}>
          <div className="border-b border-gray-100 mb-4">
            <span className="text-lg font-semibold text-gray-600">Filters</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <DateInput
              label="Start Date"
              value={dateFilters.start}
              onChange={e => setDateFilters({ ...dateFilters, start: e.target.value })}
            />
            <DateInput
              label="End Date"
              value={dateFilters.end}
              onChange={e => setDateFilters({ ...dateFilters, end: e.target.value })}
            />
          </div>

          <div className="flex gap-2 mt-5 border-t border-gray-200 pt-4">
            <Button
              name="GENERATE VIEW"
              icon={<RestartAltIcon />}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 border-none shadow cursor-pointer font-bold rounded-lg"
              onClick={onGenerate}
            />
            <Button
              name="UPLOAD CSV"
              icon={<FileUploadIcon />}
              className="bg-green-600 hover:bg-green-700 text-white px-5 py-3 border-none shadow cursor-pointer font-bold rounded-lg"
              onClick={() => setIsUploadModalOpen(true)}
            />
          </div>
        </div>

        <SearchBar handleFilter={handleSearch} />

        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <CreateTable
            tableName="CvtLogsTable"
            headers={headers}
            accessors={accessors}
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={10}
            totalItems={data.length}
            customCellRenderer={renderCell}
          />
        </div>
      </div>

      <UploadCvtLogsPreviewModal
        isOpen={isUploadModalOpen}
        onClose={() => {
          setIsUploadModalOpen(false);
          setPreviewData([]);
        }}
        onSubmit={onFinalSubmit}
        previewData={previewData}
        onFileSelect={processCsvFile}
        loading={loading}
      />
    </div>
  );
};

export default UploadCvtLogsModule;